import React from 'react'

export default function CompetencieswithioutComma({ formData }) {
    return (
        <div>
            {formData.skills &&
                Array.isArray(formData.skills) &&
                formData.skills.map((item, index) => (
                    <span key={index}>
                        {item.title}
                        {index < formData.skills.length - 1 && <span>, </span>}
                    </span>
                ))}
        </div>
    )
}
